<span class="hover-content flex-text-ellipsis">
  <ng-content></ng-content>
</span>
<a *ngIf="route && route.length" class="hover-icon" [routerLink]="route">
  <i class="icon ic-eye ml-2"></i>
</a>